import React from 'react'
import cx from 'classnames'
import { useDevice } from 'device'

import { useUser } from 'modules/user'
import { useCandleSubscription } from 'modules/subscription'

import { Text } from 'components/dataDisplay'

import messages from 'compositions/modals/SearchModal/messages'
import { ProductsGrid } from 'compositions/modals/SearchModal/components'
import { useTopRatedProducts } from 'compositions/modals/SearchModal/util'
import CandleSubscribeSmallBanner from 'compositions/banners/CandleSubscribeSmallBanner/CandleSubscribeSmallBanner'


type TopRatedProductsProps = {
  className?: string
  withBanner?: boolean
  title?: React.ReactElement
}

const TopRatedProducts: React.FunctionComponent<TopRatedProductsProps> = (props) => {
  const { className, title, withBanner } = props

  const { gender } = useUser()
  const { isMobile } = useDevice()

  const { products, isFetching: isFetchingProducts } = useTopRatedProducts({ gender })
  const { candleSubscription, isFetching: isCandleSubscriptionFetching } = useCandleSubscription()

  const isFetching = isFetchingProducts || isCandleSubscriptionFetching
  const isBannerVisible = withBanner && !isFetching && candleSubscription?.isEnabled && !candleSubscription?.isSelected

  if (!isFetching && !products?.length) {
    return (
      <Text
        className={cx(isMobile ? 'mt-20' : 'mt-36', { 'text-center': !isMobile })}
        style="p2"
        message={messages.somethingWrong}
        data-testid="somethingWrong"
      />
    )
  }

  if (isBannerVisible) {
    const firstProducts = products.slice(0, 4)
    const secondProducts = products.slice(4)

    return (
      <>
        {title}
        <ProductsGrid
          className={className}
          query=""
          products={firstProducts}
          data-testid="topRatedProducts"
        />
        <CandleSubscribeSmallBanner
          className="my-32"
          placement="Search"
        />
        <ProductsGrid
          query=""
          products={secondProducts}
          data-testid="topRatedProducts2"
        />
      </>
    )
  }

  return (
    <>
      {title}
      <ProductsGrid
        className={className}
        query=""
        products={products}
        isFetching={isFetching}
        data-testid="topRatedProducts"
      />
    </>
  )
}

export default TopRatedProducts
